<template>
  <el-descriptions class="margin-top" v-bind="$attrs">
    <!--    <template slot="extra">-->
    <!--      <el-button type="primary" size="small">操作</el-button>-->
    <!--    </template>-->
    <el-descriptions-item v-for="item in descKeys" :key="item" :labelStyle="{ 'font-weight': fw, 'font-size': fs }"
      :contentStyle="{ 'font-weight': fw, 'font-size': fs }">
      <template slot="label">
        {{ desc[item].title }}
      </template>
      
      <span :class="desc[item].title == '批次包编码' ? 'Highlight' : ''">
        
        <template v-if="desc[item].sort">
          <slot :name="desc[item].sort" ></slot>
        </template>
        <span v-else>{{ desc[item].value }}</span>
      </span>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "DescCom",
  props: {
    desc: {
      type: Object,
      required: true
    },
    fs: {
      type: String,
      default: _ => '14px'
    },
    fw: {
      type: String | Number,
      default: _ => 500
    }
  },
  data() {
    return {}
  },
  computed: {
    descKeys: function () {
      return Object.keys(this.desc)
    }
  }
}
</script>

<style scoped lang="stylus">
.margin-top{
}
.Highlight{
  font-weight: bold;
  font-size: 18px;
  color: #CD2626
}
</style>